import produce from "immer";
import * as types from "../types";

const initialState = {
  operadores: [],
  operadoresExportar: [],
  operador: {},
  isLoading: false,
  error: null,
  page: 1,
  pageSize: 25,
  pageMax: false,
  dataBuscar: {},
  showModal: false,
  editMode: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_OPERADORES:
    case types.GET_OPERADORES_EXPORTAR:
    case types.GET_OPERADOR:
    case types.CREATE_OPERADOR:
    case types.UPDATE_OPERADOR:
    case types.DELETE_OPERADOR:
    case types.TOGGLE_OPERADOR_ESTATUS:
      return produce(state, (draft) => {
        draft.isLoading = true;
      });
    case types.GET_OPERADORES_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.operadores = action.payload.operadores;
        draft.pageMax = action.payload.next === null;
        draft.error = null;
        draft.dataBuscar = action.payload.dataBuscar
          ? action.payload.dataBuscar
          : {};
        if (action.payload.buscando) draft.page = 1;
      });
    case types.OPERADORES_NEXT_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page + 1;
      });
    case types.OPERADORES_PREV_PAGE:
      return produce(state, (draft) => {
        draft.page = draft.page - 1;
      });
    case types.OPERADORES_CHANGE_PAGE_SIZE:
      return produce(state, (draft) => {
        draft.page = 1;
        draft.pageSize = action.payload;
      });
    case types.OPERADORES_SHOW_MODAL:
      return produce(state, (draft) => {
        draft.showModal = true;
      });
    case types.OPERADORES_HIDE_MODAL:
      return produce(state, (draft) => {
        draft.showModal = false;
        draft.editMode = false;
        draft.operador = {};
        draft.error = null;
      });
    case types.CREATE_OPERADOR_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.showModal = false;
      });
    case types.GET_OPERADOR_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = true;
        draft.showModal = true;
        draft.operador = action.payload;
      });
    case types.UPDATE_OPERADOR_SUCCESS:
    case types.DELETE_OPERADOR_SUCCESS:
    case types.TOGGLE_OPERADOR_ESTATUS_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = null;
        draft.editMode = false;
        draft.operador = {};
        draft.showModal = false;
      });
    case types.OPERADORES_ERROR:
      return produce(state, (draft) => {
        draft.isLoading = false;
        draft.error = action.payload ? action.payload : "offline";
      });
    case types.OPERADORES_SET_EXPORTANDO:
      return produce(state, (draft) => {
        draft.exportando = action.payload;
      });
    case types.GET_OPERADORES_EXPORTAR_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoading = false;
        // draft.showModal = false;
        draft.operadoresExportar = action.payload.operadoresExportar;
        draft.error = null;
        draft.exportando = true;
      });
    default:
      return state;
  }
};
